module.exports = __webpack_public_path__ + "static/media/japaneselanguageteacher.622b9a19.jpg";